export const dummyValue = "✖"

export function isDummy(node) { return node.name === dummyValue }
